import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface GenericTabProps {
  integration: Integration | null;
}

function GenericTab({ integration }: GenericTabProps) {
  return (
    <div className="space-y-6">
      <FormField>
        <FormLabel htmlFor="generic_url">URL Genérica</FormLabel>
        <FormInput id="generic_url" name="generic_url" defaultValue={integration?.generic_url} />
      </FormField>

      <FormField>
        <FormLabel htmlFor="generic_token">Token</FormLabel>
        <FormInput
          type="password"
          id="generic_token"
          name="generic_token"
          defaultValue={integration?.generic_token}
        />
      </FormField>
    </div>
  );
}

export default GenericTab;
